module.exports = __webpack_public_path__ + "static/media/29.a50863e9.JPG";